import { gql } from '@apollo/client';

const SPECIALIZATION_FIELDS = gql`
    fragment SpecializationFields on specializations {
        id
        name
    }
`;

const DOCUMENT_FIELDS = gql`
    fragment DocumentFields on documents {
        id
        name
    }
`;

const FETCH_CLINICS_FIELDS = gql`
    fragment ClinicFields on Clinic {
      id
      code
      name
      referral_network {
        id
        uuid
        name
      }
      organization {
        id
        name
      }
      full_address
      is_order
    }
`;

const CLINIC_FIELDS = gql`
    fragment ClinicFields on Clinic {
      id
      code
      name
      extra_info
      referral_network {
        id
        uuid
        name
      }
      full_address
      address {
        line1
        city
        state
        zip
      }
      specializations: clinic_specializations {
        id
        name
      }
      providers {
        id
        title
        display_name
        specializations {
          id
          name
        }
        documents {
          id 
          required
          document {
            id
            name
          }
          question {
            id
            uuid
            question
          }
        }
      }
      organization {
        id
        name
      }
      is_order
    }
`;

const CLINIC_TAG_FIELDS = gql`
    fragment ClinicTagFields on ClinicTag {
        id
        tag
        immutable
    }
`;

export {
    SPECIALIZATION_FIELDS,
    DOCUMENT_FIELDS,
    CLINIC_FIELDS,
    FETCH_CLINICS_FIELDS,
    CLINIC_TAG_FIELDS,
};
